import { createSelector } from 'reselect'
import initialState from 'SRC/modules/redux/initialState'

export const getPagination = createSelector(
  state => state && state.user && state.user.list && state.user.list.pagination
    ? state.user.list.pagination : initialState.user.list.pagination,
  params => params
)
